import React from "react"
import moment from "moment"
import { Link } from "react-router-dom"

const capitalizeFirst = value =>
  value ? value.charAt(0).toUpperCase() + value.slice(1) : ""

const formatPerson = person => {
  const name = [person?.firstName, person?.lastName].filter(Boolean).join(" ")

  if (name && person?.userId) return `${name} (#${person.userId})`
  if (name) return name
  if (person?.userId) return `Administrator #${person.userId}`
  return "Administrator not recorded"
}

const getRecordedLevel = value =>
  value === undefined || value === null || value === "" ? null : value

export const getLevelChangePresentation = change => {
  const gameLevel =
    change?.body?.gameLevel || change?.body?.player?.gameLevel || {}
  const sportType = change?.body?.sportType

  return {
    doubles: getRecordedLevel(gameLevel?.doubles),
    singles: getRecordedLevel(gameLevel?.singles),
    sportLabel: sportType
      ? capitalizeFirst(sportType)
      : "Sport not recorded",
  }
}

const formatAudit = (cellContent, change) => {
  const date = change?.createdAt ? moment(change.createdAt) : null
  const adminLabel = formatPerson(change?.admin)

  return (
    <div style={{ minWidth: "190px", whiteSpace: "normal" }}>
      <div className="font-weight-semibold">
        {date?.isValid()
          ? date.format("D MMM YYYY, HH:mm")
          : "Date not recorded"}
      </div>
      <div className="text-muted font-size-12 mt-1">
        {change?.admin?.id ? (
          <Link to={`/accounts/admins/${change.admin.id}`}>{adminLabel}</Link>
        ) : (
          adminLabel
        )}
      </div>
      {change?._id && (
        <div className="text-muted font-size-11 mt-1" title={change._id}>
          Audit …{change._id.slice(-8)}
        </div>
      )}
    </div>
  )
}

const formatSport = (cellContent, change) => {
  const presentation = getLevelChangePresentation(change)

  return (
    <div style={{ minWidth: "130px" }}>
      <div className="font-weight-semibold">{presentation.sportLabel}</div>
      <div className="text-muted font-size-11 mt-1">Competitive profile</div>
    </div>
  )
}

const formatLevels = (cellContent, change) => {
  const presentation = getLevelChangePresentation(change)

  return (
    <div style={{ minWidth: "280px", whiteSpace: "normal" }}>
      <div className="text-muted font-size-11 mb-2">Resulting levels</div>
      <div className="d-flex flex-wrap">
        <div className="bg-light rounded px-3 py-2 mr-2 mb-1">
          <div className="text-muted font-size-11">Singles</div>
          <div className="font-weight-semibold">
            {presentation.singles === null
              ? "Not recorded"
              : `Level ${presentation.singles}`}
          </div>
        </div>
        <div className="bg-light rounded px-3 py-2 mb-1">
          <div className="text-muted font-size-11">Doubles</div>
          <div className="font-weight-semibold">
            {presentation.doubles === null
              ? "Not recorded"
              : `Level ${presentation.doubles}`}
          </div>
        </div>
      </div>
    </div>
  )
}

const levelChangeColumns = () => [
  {
    dataField: "createdAt",
    formatter: formatAudit,
    headerStyle: { width: "30%" },
    text: "Change audit",
  },
  {
    dataField: "sportType",
    formatter: formatSport,
    headerStyle: { width: "20%" },
    text: "Sport",
  },
  {
    dataField: "gameLevel",
    formatter: formatLevels,
    headerStyle: { width: "50%" },
    text: "Levels after change",
  },
]

export default levelChangeColumns
